import { useQuery } from '@tanstack/react-query'

import { UserPkg } from '@/api/user-package/types/UserPkg'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPackageFeesByPackageId } from '../packageReqService'

export const usePackageFeesFromRequests = (pkg: UserPkg | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PACKAGE_REQUESTS, 'fees', pkg?.id],
    queryFn: () => getPackageFeesByPackageId(pkg!.id!),
    enabled: !!pkg?.id,
  })
}
